import { getListViewDimensions } from './getListViewDimensions';
import { LIST_VIEW_NOTIFICATION_PADDING_V9 } from '../internalConstants';
import { getMinListViewWidth } from './getMinListViewWidth';

export function getListViewNotificationDimensions(): {
    minWidth: number;
    maxWidth: number;
} {
    const listViewWidth = getListViewDimensions().listViewWidth;

    return {
        minWidth: getMinListViewWidth() - LIST_VIEW_NOTIFICATION_PADDING_V9,
        maxWidth: listViewWidth - LIST_VIEW_NOTIFICATION_PADDING_V9,
    };
}
